import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    HStack,
    Switch,
} from '@chakra-ui/react';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';

const GlobalEntityField = ({
    darkMode,
    values,
    setFieldValue,
    ufGlobalEntityCheckbox,
    isReadOnly = false,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { requiredScope } = useSelector((state) => state.login);

    // Prevent label click from toggling switch
    const handleLabelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    if (requiredScope < 80) {
        return null;
    }

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box onClick={handleLabelClick}>
                    <FormLabel
                        sx={formLabelStyling(darkMode)}
                        htmlFor={undefined}
                        onClick={handleLabelClick}>
                        Global Entity
                    </FormLabel>
                    <Text
                        sx={descriptionStyling}
                        maxWidth={250}
                        onClick={handleLabelClick}>
                        Mark this number block as a global entity.
                    </Text>
                </Box>
                <Box flex="1" minWidth={0}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            paddingTop: '20px',
                        }}>
                        <HStack spacing={4} alignItems="center">
                            <Switch
                                id="global-entity-switch"
                                isChecked={values.globalEntity}
                                isDisabled={isReadOnly}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    setFieldValue(
                                        'globalEntity',
                                        !values.globalEntity,
                                    );
                                }}
                                marginRight={2}
                                data-walkthroughid={ufGlobalEntityCheckbox}
                                colorScheme="brand"
                            />
                            {isHovered && (
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    ml={3}
                                    position="relative"
                                    top="2px">
                                    <FieldToolTip
                                        label="Mark this number block as a global entity."
                                        ariaLabel="global-entity-tip"
                                        left="5px"
                                        bottom="5px"
                                    />
                                </Box>
                            )}
                        </HStack>
                    </Box>
                </Box>
            </Stack>
        </FormControl>
    );
};

export default GlobalEntityField;
